// @Vendors
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Switch, Redirect, withRouter } from 'react-router-dom';

// @State
import { checkAuthentication } from '../../state/auth/auth.actions';
import { clearServerErrors, clearServerSuccess } from '../../state/app/app.actions';
import { selectServerErrors, selectServerSuccess } from '../../state/app/app.selectors';

// @Pages
import Dashboard from '../Dashboard';
import Login from '../Login';

// @Components
import PrivateRoute from './Routes/PrivateRoute';
import LoginRoute from './Routes/LoginRoute';
import Snackbars from '../../components/Snackbars';
import SnackbarsSuccess from '../../components/SnackbarsSuccess';

// @Styles
import '../../styles/style.css';

class App extends Component {

  componentDidMount = () => {
    const { checkAuthentication } = this.props;
    checkAuthentication();

    // load important data
  }

  render() {
    const { clearServerErrors, serverErrors, serverSuccess, clearServerSuccess } = this.props;
    return (
      <Fragment>
        <Snackbars onClose={clearServerErrors} message={serverErrors} open={!!serverErrors} />
        <SnackbarsSuccess  onClose={clearServerSuccess} message={"Operación se realizó exitosamente"} open={!!serverSuccess} />
        <Switch>
          <PrivateRoute alias="dashboard" exact path="/" component={Dashboard} />
          <LoginRoute alias="login" exact path="/login" component={Login} />
          <Redirect to="/" />
        </Switch>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  serverErrors: selectServerErrors(state),
  serverSuccess: selectServerSuccess(state)

});

const actions = {
  checkAuthentication,
  clearServerErrors,
  clearServerSuccess
};

export default withRouter(
  connect(
    mapStateToProps,
    actions
  )(App)
);



// WEBPACK FOOTER //
// ./src/pages/App/index.js